import { UI } from "../UI/UI";
import { DisplayToastrError } from "source/app/presentation/Shared/HandleError";
export const GetNewEntrySignificance = (newEntry: string) => {
    if (!newEntry) throw new Error("Missing new entry value");

    const entrySignificance = UI.GetEntrySignificance(newEntry);

    if (entrySignificance > 3 || entrySignificance < 0) {
        DisplayToastrError(
            "Did you put a space after the entry symbol?",
            "The Game says"
        );
        return false;
    }

    return true;
};
